import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  disableAllSubmit(event) {
    if (event.submitter && event.submitter.type === "submit") {
      event.submitter.disabled = true
      return
    }

    this.element
      .querySelectorAll('button[type="submit"], input[type="submit"]')
      .forEach((el) => {
        el.disabled = true
      })
  }
}
